import type { TFunction } from 'i18next';

export const getDurationOptionLabel = (duration: string | null, t: TFunction<'translation'>) => {
  if (!duration) return '';
  return `${duration} ${t(`Second${duration === '1' ? '' : 's'}`)}`;
};
